module.exports = __webpack_public_path__ + "static/media/qr_demo.92343bf3.png";